<template>
    <div class="main-container">
        <div class="filter-container">
            <el-input class="filter-item" v-model="filters.order_no" placeholder="蛋叔订单号" style="width:200px"></el-input>
            <el-select class="filter-item" v-model="filters.money_type" placeholder="变动类型" style="width:150px">
                <el-option label="充值" value="1"></el-option>
                <el-option label="消费" value="2"></el-option>
                <el-option label="退款" value="3"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.order_type" placeholder="订单类型" style="width:150px">
                <el-option label="实物类" value="1"></el-option>
                <el-option label="电子劵" value="2"></el-option>
                <!-- <el-option label="电影票" value="3"></el-option> -->
            </el-select>
            <el-date-picker
                class="filter-item"
                type="date"
                placeholder="选择开始日期"
                v-model="filters.start_time"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledStartDate">
            </el-date-picker>
            <el-date-picker
                class="filter-item"
                type="date"
                placeholder="选择结束日期"
                v-model="filters.end_time"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledEndDate">
            </el-date-picker>
            <div class="filter-item">
                <el-checkbox v-model="filters.is_history" @change="onHistoryChange">历史订单</el-checkbox>
            </div>
            <el-button class="filter-btn" type="primary" @click="onBack">返回</el-button>
            <el-button class="filter-btn" type="primary" @click="onSearch">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="onExport">导出</el-button>
        </div>
        <el-table :data="orderList" stripe border style="width:100%">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="order_no" label="蛋叔订单号"></el-table-column>
            <el-table-column prop="out_order_no" label="渠道方订单号"></el-table-column>
            <el-table-column prop="money_type" label="渠道方订单号"></el-table-column>
            <el-table-column prop="money" label="金额"></el-table-column>
            <el-table-column prop="remain_money" label="剩余金额"></el-table-column>
            <el-table-column prop="created_at" label="创建时间"></el-table-column>
        </el-table>
        <el-pagination
            @current-change="onCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next, jumper"
            :page-size="pageSize"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import Keys from '@/constant/key'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { dateFormat } from '../../utils/index'
export default defineComponent({
name: 'PrevPayList',

setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const route = useRoute()
    
    const data = reactive({
        filters: { // 筛选项
            channel_no: route.query.channel_no,
            start_time: '',
            end_time: '',
            money_type: '',
            order_type: '',
            order_no: '',
            is_history: false
        },

        orderList: [], // 订单列表
        total: 0,
        pageSize: 10,
        currentPage: 1,

        // 开始日期禁用逻辑
        disabledStartDate: (time) => {
            if (data.filters.is_history) {
                // 历史订单：不限开始时间
                return false
            }
            // 非历史订单：只能选 2026-01-01 及以后
            return time.getTime() < new Date('2026-01-01').getTime()
        },
        // 结束日期禁用逻辑
        disabledEndDate: (time) => {
            if (data.filters.is_history) {
                // 历史订单：结束时间须为 2025-12-31 之前
                return time.getTime() >= new Date('2025-12-31').getTime()
            }
            // 非历史订单：不限结束时间
            return false
        },

        // 历史订单切换
        onHistoryChange: () => {
            data.currentPage = 1
            if (data.filters.is_history) {
                // 历史订单：默认 2025-12-31 ~ 2025-12-31
                data.filters.start_time = '2025-12-31'
                data.filters.end_time = '2025-12-31'
            } else {
                // 非历史订单：默认当天
                data.filters.start_time = dateFormat(new Date())
                data.filters.end_time = dateFormat(new Date())
            }
            data.getOrderList()
        },

        // 获取订单列表
        getOrderList: () => {
            if (!data.filters.start_time) {
                if (data.filters.is_history) {
                    data.filters.start_time = '2025-12-31'
                } else {
                    data.filters.start_time = dateFormat(new Date())
                }
            }
            if (!data.filters.end_time) {
                if (data.filters.is_history) {
                    data.filters.end_time = '2025-12-31'
                } else {
                    data.filters.end_time = dateFormat(new Date())
                }
            }
            const apiPath = data.filters.is_history ? '/channel/discount_info_his' : '/channel/discount_info'
            proxy.$http.get(`${apiPath}?channel_no=${data.filters.channel_no}&start_time=${data.filters.start_time}&end_time=${data.filters.end_time}&money_type=${data.filters.money_type}&order_no=${data.filters.order_no}&page=${data.currentPage}&page_size=${data.pageSize}&order_type=${data.filters.order_type}`).then(res => {
                if (res.code == 200) {
                    data.orderList = res.data.data
                    data.total = res.data.total
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 翻页
        onCurrentChange: (val) => {
            data.currentPage = val
            data.getOrderList()
        },
        // 返回上一页
        onBack: () => {
            router.go(-1)
        },
        // 搜索
        onSearch: () => {
            if (data.filters.start_time && data.filters.end_time) {
                if (new Date(data.filters.end_time) < new Date(data.filters.start_time)) {
                    return proxy.$message({ type: 'error', message: '结束日期必须大于或等于开始日期' })
                }
            }
            data.currentPage = 1
            data.getOrderList()
        },
        // 导出
        onExport: () => {
            let url = '/channel/discount_info'
            if (data.filters.is_history) {
                url = '/channel/discount_info_his'
            }
            window.open(`${Keys.baseUrl + url}?channel_no=${data.filters.channel_no}&start_time=${data.filters.start_time}&end_time=${data.filters.end_time}&money_type=${data.filters.money_type}&order_no=${data.filters.order_no}&page=${data.currentPage}&page_size=${data.pageSize}&educe=1`)
        }
    })

    data.getOrderList()

    return { ...toRefs(data) }
}
})
</script>

<style lang="stylus" scoped>
</style>